import React from 'react';
import './Notification.css';

export default function NotificationContainer({ notifications, onRemove }) {
  if (!notifications || notifications.length === 0) return null;
  return (
    <div className="notification-container">
      {notifications.map(n => (
        <div key={n.id} className={`notification notification-${n.type}`}>
          <div className="notification-icon">
            {n.type === 'success' && <span>&#10003;</span>}
            {n.type === 'error' && <span>&#10007;</span>}
            {n.type === 'warning' && <span>&#9888;</span>}
            {n.type === 'info' && <span>&#8505;</span>}
            {n.type === 'loading' && <span className="notification-spinner" />}
          </div>
          <div className="notification-body">
            <span className="notification-message">{n.message}</span>
          </div>
          <button className="notification-close" onClick={() => onRemove(n.id)}>&#215;</button>
        </div>
      ))}
    </div>
  );
}
